import type { ReactNode } from 'react'
import * as React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import CartPanelItemDispatcher from './CartPanelItemDispatcher'
import type { CartPanelFlightItem, CartPanelItem } from '../hooks/useCartPanelItems'
import { CART_PANEL_DESKTOP_LAYOUT_MIN_WIDTH } from './cartPanelConstants'
import { cartPanelMobileSectionHeaderPaddingStyles } from './cartPanelLayout.styles'

const SectionRoot = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0;
`

const SectionHeader = styled.div`
  background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
  ${cartPanelMobileSectionHeaderPaddingStyles}

  @container (min-width: ${rem(CART_PANEL_DESKTOP_LAYOUT_MIN_WIDTH)}) {
    padding-block-end: ${rem(12)};
    padding-inline: 0;
    background-color: transparent;
  }
`

const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
`

interface Props {
  title: string
  icon: ReactNode
  items: Array<CartPanelItem>
  onToggleInclude: (item: CartPanelItem) => void
  onChooseFlight: (item: CartPanelFlightItem) => void
  onRefreshFlight: (item: CartPanelFlightItem) => void
  onChangeFlight: (item: CartPanelFlightItem) => void
  onViewFlightDetails: (item: CartPanelFlightItem) => void
  refreshingFlightKey: string | undefined
  onDelete: (item: CartPanelItem) => void
  isStreaming: boolean
}

function CartPanelSection({
  title,
  icon,
  items,
  onToggleInclude,
  onChooseFlight,
  onRefreshFlight,
  onChangeFlight,
  onViewFlightDetails,
  refreshingFlightKey,
  onDelete,
  isStreaming,
}: Props) {
  return (
    <SectionRoot data-testid="cart-panel-section">
      <SectionHeader data-testid="cart-panel-section-header">
        <HeadingTextBlock startIcon={icon} variant="heading5">{title}</HeadingTextBlock>
      </SectionHeader>
      <ItemList>
        {items.map((item) => (
          <CartPanelItemDispatcher
            key={item.key}
            item={item}
            onToggleInclude={onToggleInclude}
            onChooseFlight={onChooseFlight}
            onRefreshFlight={onRefreshFlight}
            onChangeFlight={onChangeFlight}
            onViewFlightDetails={onViewFlightDetails}
            refreshingFlightKey={refreshingFlightKey}
            onDelete={onDelete}
            isStreaming={isStreaming}
          />
        ))}
      </ItemList>
    </SectionRoot>
  )
}

export default CartPanelSection
